/* eslint-disable import/prefer-default-export */
import { GET_FAQS } from '../../types/Types';

export const faqs = (data) => ({
  type: GET_FAQS,
  data,
});
